import { createStyles, makeStyles } from '@material-ui/core';

const StageCompletionStyles = makeStyles((theme) =>
  createStyles({
    grid: {
      width: '100%',
    },
    stageCompletionHeading: {
      margin: '0.625rem 0rem',
    },
    stageCompletionText: {
      margin: '0.625rem 0rem',
    },
    staticPageIcon: {
      marginBottom: '1.25rem',
      '& .colorChange': {
        fill: theme.palette.primary.main,
      },
      '& .backgroundFill': {
        fill: theme.palette.svgStyles?.fill,
        stroke: theme.palette.svgStyles?.stroke,
      },
      '& path.colorChangeStroke': {
        stroke: theme.palette.primary.main,
      },
      '& .customFillElement': {
        fill: theme.palette.svgStyles?.fillForElements,
      },
    },
    staticPageButtom: {
      marginTop: '1.5625rem',
    },
  }),
);

export default StageCompletionStyles;
